<ng-container *ngIf="page | async as page">
  <app-navigation [environment]="page.environment | getFields"></app-navigation>
  <main>
    <app-block-builder [blocks]="page.blocks | getFields"></app-block-builder>
  </main>
  <app-footer [environment]="page.environment | getFields"></app-footer>
</ng-container>
